import { render, staticRenderFns } from "./ShipOceanRaceDashboardWidget.vue?vue&type=template&id=64b9fc06&scoped=true"
import script from "./ShipOceanRaceDashboardWidget.vue?vue&type=script&lang=js"
export * from "./ShipOceanRaceDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./ShipOceanRaceDashboardWidget.vue?vue&type=style&index=0&id=64b9fc06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b9fc06",
  null
  
)

export default component.exports